import React, { useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
  INPUT_LENGTH_15,
  PHONE_NO_LENGTH,
  SWAL_SETTINGS,
  TEXTAREA_MAX_LENGTH,
} from "../../../../utils/Constants";
import {
  blockInvalidChar,
  DT,
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { Add } from "../../services/usermgmt.services";
import { cuisineOptions } from "../../../../utils/Constants";
import { TagPicker, Tooltip, Whisper } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import PhoneWorkInput from "../../../../utils/PhoneWorkInput";
import { PHONE_VALIDATION } from "../../../../utils/commonValidations";

const UsersAdd = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Wellness Centre"),
      url: "/admin/center-management/center/list/1",
    },
    { title: t("admin.cafes.link_add"), url: "" },
  ];

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim()
    .min(3, "Centre name must be at least 3 characters.")
    .max(150, "Centre name must not be more than 150 characters.")
    .matches(/^[a-zA-Z0-9\s&\-'.]+$/, "Centre name can only contain letters, numbers, spaces, and common punctuation.")
    .required("Centre name is required"),
    // email: Yup.string()
    // .trim()
    // .required("admin.cafes.label_email_required_error")
    // .email("admin.cafes.label_email_invalid_format_error")
    // .matches(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/, "admin.cafes.label_email_invalid_format_error")
    // .test('no-uppercase', "admin.cafes.label_email_uppercase_error", function (value) {
    //   if (value) {
    //     return !/[A-Z]/.test(value);
    //   }
    // }),
    email: Yup.string()
    .trim()
    .required("admin.cafes.label_email_required_error")
    .email("admin.cafes.label_email_invalid_format_error")
    .matches(
      /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      "admin.cafes.label_email_invalid_format_error"
    ),  
    phone_number: PHONE_VALIDATION,
    address: Yup.string().trim().max(TEXTAREA_MAX_LENGTH, "Location must not be more than 150 characters.").required("Location is required"),
    charge_per_patient: Yup.number().required("Charge per patient is required"),
    profile_image: Yup.mixed()
      .nullable()
      .test(
        'fileType',
        'admin.cafes.supported_file_error',
        value => !value || ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type)
      )
      .test(
        'fileSize',
        'admin.cafes.image_max_size_error',
        value => !value || value.size <= 1.5 * 1024 * 1024
      )
      .test(
        'validImage',
        'Upload a valid image',
        value =>
          new Promise(resolve => {
            if (!value || typeof value === 'string') return resolve(true);

            const reader = new FileReader();
            reader.onload = () => {
              const img = new Image();
              img.onload = () => resolve(true);
              img.onerror = () => resolve(false);
              img.src = reader.result;
            };
            reader.onerror = () => resolve(false);
            reader.readAsDataURL(value);
          })
      ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      email: "",
      address: "",
      // address1: "",
      // address2: "",
      city: "",
      pin_code: "",
      phone_number: "",
      phone_number_work: "",
      profile_image: "",
      charge_per_patient: ""
    },
    validateOnBlur: false,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      setSubmitted(true);
      let formData = new FormData();
      formData.append("center_name", values.name);
      formData.append("email", values.email.toLowerCase());
      formData.append("address", values.address);
      // formData.append("address1", values.address1);
      // formData.append("address2", values.address2);
      formData.append("city", values.city);
      formData.append("pin_code", values.pin_code);
      formData.append("phone_number", values.phone_number);
      formData.append("phone_number_work", values.phone_number_work);
      formData.append("logo", values.profile_image);
      formData.append("charge_per_patient", values.charge_per_patient);

      Add(formData)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            resetForm({ values: "" });
            navigate(`/admin/center-management/center/list/1`);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            setSubmitted(false);
          }
        })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    },
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    Add Centre
                  </h6>
                </div>
                <div className="row row-sm">


                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("Centre Name")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      className="form-control"
                      placeholder={t("Enter centre name")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[INPUT_LENGTH_15]} name="name" form={formik} />
                    </span>
                    {/* <span>DT(t(form.errror), [])</span> */}
                  </div>

                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="email" className="text-left d-flex">
                      {t("admin.cafes.label_email")}:<span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="email"
                      id="email"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      className="form-control"
                      placeholder={t("admin.cafes.placeholder_email")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="email" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="address" className="text-left d-flex">
                      {t("Location")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="address"
                      id="address"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address}
                      className="form-control"
                      placeholder={t("Enter location")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[TEXTAREA_MAX_LENGTH]} name="address" form={formik} />
                    </span>
                  </div>
                  {/* <div className="col-md-6 text-center form-group">
                    <label htmlFor="address1" className="text-left d-flex">
                      {t("Address 1")}:
                    </label>
                    <input
                      name="address1"
                      id="address1"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address1}
                      className="form-control"
                      placeholder={t("Enter address 1")}
                    />
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="address2" className="text-left d-flex">
                      {t("Address 2")}:
                    </label>
                    <input
                      name="address2"
                      id="address2"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address2}
                      className="form-control"
                      placeholder={t("Enter address 2")}
                    />
                  </div> */}

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="city" className="text-left d-flex">
                      {t("City")}:
                      {/* <span className="requirestar">*</span>{" "} */}
                    </label>
                    <input
                      name="city"
                      id="city"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.city}
                      className="form-control"
                      placeholder={t("Enter city")}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[TEXTAREA_MAX_LENGTH]} name="address2" form={formik} />
                    </span> */}
                  </div>

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="pin_code" className="text-left d-flex">
                      {t("PIN Code")}:
                      {/* <span className="requirestar">*</span>{" "} */}
                    </label>
                    <input
                      name="pin_code"
                      id="pin_code"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pin_code}
                      className="form-control"
                      placeholder={t("Enter PIN code")}
                      onKeyDown={blockInvalidChar}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[TEXTAREA_MAX_LENGTH]} name="address2" form={formik} />
                    </span> */}
                  </div>

                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex" htmlFor="phone_number">
                      {t("admin.cafes.label_phone_number")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <PhoneInput
                      name="phone_number"
                      id="phone_number"

                      onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }}

                      onBlur={formik.handleBlur}
                      value={formik.values.phone_number}
                      className="form-control"
                      placeholder={t('admin.cafes.placeholder_phone_number')}

                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="phone_number" form={formik} shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                    </span>
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex" htmlFor="phone_number">
                      {t("Phone Number Work")}:
                    </label>
                    <PhoneWorkInput
                      name="phone_number_work"
                      id="phone_number_work"

                      onChange={(e) => { formik.setFieldValue('phone_number_work', e?.phone_number_work) }}

                      onBlur={formik.handleBlur}
                      value={formik.values.phone_number_work}
                      className="form-control"
                      placeholder={t('Enter phone number work')}

                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="phone_number_work" form={formik} shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                    </span> */}
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="charge_per_patient" className="text-left d-flex">
                      {t("Charge As Per Diet Chart")}:<span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="charge_per_patient"
                      id="charge_per_patient"
                      type="number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.charge_per_patient}
                      className="form-control"
                      placeholder={t("Enter charge per diet chart")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="charge_per_patient" form={formik} />
                    </span>
                  </div> 

                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="profile_image" className="text-left d-flex">
                      {t("admin.cafes.label_logo")}:
                      {" "}
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            {t("admin.cafes.image_support_tooltip")}
                          </Tooltip>
                        }
                      >
                        <span className="field-more-info mt-1 ms-1 cp">
                          ?
                        </span>
                      </Whisper>
                    </label>
                    <input
                      className="form-control imgInput"
                      id="profile_image"
                      name="profile_image"
                      accept="image/*"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "profile_image",
                          event.target.files[0] || ""
                        );
                        event.target.files.length === 1
                          ? setPreviewImage(
                            URL.createObjectURL(event.target.files[0])
                          )
                          : setPreviewImage("");
                      }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="profile_image" form={formik} />
                    </span>

                    {previewimage ? (
                      <ul className="question-image-preview questions-ul">
                        <li className="pr_img_box">
                          <img
                            src={previewimage}
                            style={{ height: "100px" }}
                            alt={"Profile_Img"}
                          />
                          <div className="img_options">
                            <button type="button" className="text-danger"
                              onClick={() => {
                                // console.log(previewResImage , previewimage)
                                setPreviewImage("");
                                formik.setFieldValue("profile_image", null);
                                document.getElementById("profile_image").value = ""
                              }}>
                              <i className="ri-delete-bin-6-fill"></i>
                            </button>
                          </div>
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-5">
                    <button
                      className="btn btn-info mr-2"
                      type="submit"
                      disabled={submitted ? true : null}
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_submit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      disabled={submitted ? true : null}
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("admin.button.btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default UsersAdd;